export const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Top Announcement Bar */}
      <div className="bg-blue-50 text-blue-700 text-center py-2 px-4 text-xs font-medium">
        ⚡ Only 3 slots left for Founding Partner pilots
      </div>

      {/* Hero Section */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Stop leaking revenue in your pipeline.
            </h1>
            <p className="text-base md:text-lg text-gray-500 mb-3 max-w-2xl mx-auto">
              Built for agencies and teams managing HubSpot or Salesforce pipelines.
            </p>
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Identify stalled deals and revenue risk before they're lost.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a 
                href="#pilot-program" 
                className="inline-flex items-center justify-center px-6 py-3 bg-[#0D73FF] text-white font-semibold rounded-full hover:bg-[#0B5ED7] transition-colors text-lg"
              >
                Book a pilot call
              </a>
              <a 
                href="#product-preview" 
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#0D73FF] text-[#0D73FF] font-semibold rounded-full hover:bg-blue-50 transition-colors text-lg"
              >
                View product demo
              </a>
            </div>
            <p className="text-sm text-gray-500 mt-4">
              Piloted by agencies serving Real Estate and Medspa clients.
            </p>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <div className="text-center py-4 text-sm text-gray-600">
        <div className="max-w-5xl mx-auto px-4">
          Built for agencies, RevOps leaders, and founders who live in their pipeline.
        </div>
      </div>

      {/* What RiverBlue Does */}
      <section className="py-16 md:py-24 border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12">
            What RiverBlue does for your GTM
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white border border-slate-200 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Find revenue you're missing
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                RiverBlue surfaces at-risk deals, stalled opps, and inconsistent next steps that quietly kill your forecast.
              </p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Fix pipeline hygiene
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Spot missing fields, bad owner assignments, and deals that don't belong in the forecast.
              </p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Give leadership a clear view
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Turn chaos into a single, clean GTM view your CRO, RevOps, and agencies actually understand.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How the Pilot Works */}
      <section id="pilot-program" className="py-16 md:py-24 bg-white border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12">
            How the pilot works
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#0D73FF] text-white flex items-center justify-center text-xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Connect your CRM
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                We securely connect to Salesforce/HubSpot via read-only access.
              </p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#0D73FF] text-white flex items-center justify-center text-xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Review your "Revenue at Risk" dashboard
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                We walk your team through the initial findings.
              </p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#0D73FF] text-white flex items-center justify-center text-xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Decide if you want to keep it on
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                If RiverBlue clearly surfaces value, we continue. If not, you pay nothing.
              </p>
            </div>
          </div>
          <div className="text-center py-6 px-6 bg-green-50 border border-green-200 rounded-xl text-green-700 text-sm md:text-base font-medium max-w-2xl mx-auto">
            No long contracts. No pressure. If it doesn't help, we turn it off.
          </div>
        </div>
      </section>

      {/* Product Preview */}
      <section id="product-preview" className="py-16 md:py-24 border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-4">
            See the GTM Intelligence dashboard
          </h2>
          <div className="text-center">
            <p className="text-lg text-gray-600 mb-8">
              Your pipeline, fully visible.
            </p>
            <img 
              src="/product-shot.png" 
              alt="GTM Intelligence Dashboard showing Revenue at Risk, Issues by Severity heatmap, Weekly Summary, and MIN IMPACT filter" 
              className="w-full max-w-4xl h-auto rounded-2xl shadow-lg border border-slate-200 mx-auto mb-8" 
            />
            <div className="grid md:grid-cols-3 gap-4 max-w-2xl mx-auto">
              <div className="text-left text-sm text-gray-600 pl-6 relative">
                <span className="absolute left-0 text-[#0D73FF] text-xl font-bold">•</span>
                Revenue at Risk overview
              </div>
              <div className="text-left text-sm text-gray-600 pl-6 relative">
                <span className="absolute left-0 text-[#0D73FF] text-xl font-bold">•</span>
                Issues by severity and owner
              </div>
              <div className="text-left text-sm text-gray-600 pl-6 relative">
                <span className="absolute left-0 text-[#0D73FF] text-xl font-bold">•</span>
                Deal-level drill-down with recommended actions
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who RiverBlue Is For */}
      <section className="py-16 md:py-24 bg-white border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12">
            Who RiverBlue is for
          </h2>
          <div className="max-w-2xl mx-auto space-y-4">
            <div className="bg-white border border-slate-200 rounded-xl p-5 text-base text-gray-900">
              Agencies managing multiple client pipelines
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5 text-base text-gray-900">
              RevOps leaders who need a single source of GTM truth
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5 text-base text-gray-900">
              Founders who live and die by their forecast
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-16 md:py-24 border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12">
            FAQ
          </h2>
          <div className="max-w-2xl mx-auto space-y-4">
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <div className="text-base font-semibold text-gray-900 mb-2">
                Is this a full CRM?
              </div>
              <div className="text-sm md:text-base text-gray-600 leading-relaxed">
                No. RiverBlue sits on top of your existing CRM and makes it usable for revenue decisions.
              </div>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <div className="text-base font-semibold text-gray-900 mb-2">
                Which CRMs do you support?
              </div>
              <div className="text-sm md:text-base text-gray-600 leading-relaxed">
                We start with HubSpot and Salesforce, with more coming soon.
              </div>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <div className="text-base font-semibold text-gray-900 mb-2">
                What does the pilot cost?
              </div>
              <div className="text-sm md:text-base text-gray-600 leading-relaxed">
                For early Founding Partners, the pilot is free while we prove value.
              </div>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <div className="text-base font-semibold text-gray-900 mb-2">
                Is my data secure?
              </div>
              <div className="text-sm md:text-base text-gray-600 leading-relaxed">
                We use read-only connections and follow best practices for access control and data separation.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 md:py-24 bg-white border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center max-w-2xl mx-auto">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Want to see your "Revenue at Risk" view?
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-6">
              We'll review your pipeline together and show you where you're leaking revenue.
            </p>
            <a 
              href="#pilot-program" 
              className="inline-flex items-center justify-center px-6 py-3 bg-[#0D73FF] text-white font-semibold rounded-full hover:bg-[#0B5ED7] transition-colors text-lg"
            >
              Book a pilot call
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
